module.exports = __webpack_public_path__ + "81d6098a383fbb0362835254c2811450.fbx";